import { Helmet } from 'react-helmet'
import Hoverboard from './Hoverboard'

const Wrapper = () => (
  <>
    <Helmet>
      <meta charSet='utf-8' />
      <title>Hoverboard</title>
    </Helmet>
    <Hoverboard />
  </>
)
export default Wrapper
